import { PREDEFINED_TENANTS } from './main-swag.constants';
export const tenantEmailNameMap = {
  [PREDEFINED_TENANTS.SENDOSO]: 'Sendoso',
  [PREDEFINED_TENANTS.SWAG]: 'SWAG.COM',
  [PREDEFINED_TENANTS.POSTAL]: 'POSTAL',
  [PREDEFINED_TENANTS.CUSTOM_INK]: 'Custom Ink'
};